"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgSearchSecondary = function SvgSearchSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement("path", {
            d: "M31.23 27.5l-7.12-7.11a2.64 2.64 0 00-1.33-.72A12.53 12.53 0 0025 12.39a1.11 1.11 0 00-1-1.1 1.11 1.11 0 00-1.18 1.12v.12a10.19 10.19 0 01-7 9.78A10.32 10.32 0 1120.43 6c.353.43.974.525 1.44.22a1.12 1.12 0 00.28-1.66 11.34 11.34 0 00-.81-.9A12.55 12.55 0 003.3 4 12.63 12.63 0 003 20.67a12.54 12.54 0 0016.63 2.13c.106.504.356.966.72 1.33l7.11 7.11a2.66 2.66 0 003.77-3.74z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    );
};

exports.default = (0, _withContainer2.default)(SvgSearchSecondary);